module.exports = __webpack_public_path__ + "img/whatsapp.a1f62934.svg";